module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevii",
      "title": "vii"
    }
  }, [_vm._v("Acknowledgements")])]), _c('a', {
    attrs: {
      "id": "pagevii",
      "title": "vii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book is dedicated to all those who helped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were so many, but I must mention in particular:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Jim’ Ozawa, who when we regularly refought the Pacific War together, many years ago now, first introduced and explained to me the actions and motives of the Kamikaze organizers and pilots.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("David Mattiske, Maya Sieber and Simon Thayer, who between them recently revived my interest in this subject.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My agents Johnson & Alcock Limited, especially my helpful and encouraging liaison officer Ed Wilson.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My knowledgeable and industrious editor Pamela Covey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Birmingham & Midland Institute & Library, the Taylor Library and the US Navy Department of Information who assisted with the photographs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brigadier Henry Wilson and the staff of my publishers Pen & Sword Books Limited, especially Jon Wilkinson who sorted out the jacket, Dominic Allen who sorted out the plates, ‘SJ’ who sorted out the maps and the ever-patient Matt Jones and Laura Hirst who sorted out everything else.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pagevii",
      "title": "vii"
    }
  }, [_vm._v("I’m very lucky and I’m very grateful.")]), _c('a', {
    attrs: {
      "id": "pageviii",
      "title": "viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pageviii",
      "title": "viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25ffb192","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgement.vue
// module id = 69
// module chunks = 0